import { FormattedMessage } from "react-intl"
import { Fragment } from "react/jsx-runtime"

export const CorporateInfo = () => {
  return (
    <Fragment>
      <h4 className="h4 welcome-info__title text-left">
        <FormattedMessage id="corp_1" />
      </h4>
      <span className="welcome-info__verefy__text">
        <FormattedMessage id="pa_153" />
      </span>
      <p className="welcome-info__verefy-descr">
        <FormattedMessage id="corp_2" />
      </p>
      <ul className="welcome-info__controls verefy-info__controls list">
        <li className="welcome-info__verefy-list done">
          <FormattedMessage id="corp_3" />
        </li>
        <li className="welcome-info__verefy-list done">
          <FormattedMessage id="corp_4" />
        </li>
        <li className="welcome-info__verefy-list done">
          <FormattedMessage id="corp_5" />
        </li>
        <li className="welcome-info__verefy-list done">
          <FormattedMessage id="corp_6" />
        </li>
      </ul>
    </Fragment>
  )
}
